import {
  RESET_COMPANIES,
  RESET_COMPANY,
  RESET_ERROR,
  GET_COMPANIES,
  SET_COMPANIES,
  API_ERROR,
  GET_COMPANY,
  SET_COMPANY,
  CREATE_COMPANY,
  CREATE_COMPANY_SUCCESS,
  EDIT_COMPANY,
  EDIT_COMPANY_SUCCESS,
  ACTIVATE_COMPANY,
  ACTIVATE_COMPANY_SUCCESS,
  CLEAN_QUEUE,
  CLEAN_QUEUE_SUCCESS,
  RESET_SUCCESS,
} from "./actionTypes";

export const resetCompanies = () => {
  return {
    type: RESET_COMPANIES,
    payload: {},
  };
};

export const resetCompany = () => {
  return {
    type: RESET_COMPANY,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getCompanies = (page, qnt, name, email, document) => {
  return {
    type: GET_COMPANIES,
    payload: { page, qnt, name, email, document },
  };
};
export const setCompanies = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_COMPANIES,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createCompany = (newCompanyValues) => {
  return {
    type: CREATE_COMPANY,
    payload: { newCompanyValues },
  };
};
export const createCompanySuccess = (message) => {
  return {
    type: CREATE_COMPANY_SUCCESS,
    payload: { message },
  };
};

export const getCompany = (idCompany, isForm) => {
  return {
    type: GET_COMPANY,
    payload: { idCompany, isForm },
  };
};
export const setCompany = (data) => {
  return {
    type: SET_COMPANY,
    payload: { data },
  };
};

export const editCompany = (idCompany, newCompanyValues) => {
  return {
    type: EDIT_COMPANY,
    payload: { idCompany, newCompanyValues },
  };
};
export const editCompanySuccess = (message) => {
  return {
    type: EDIT_COMPANY_SUCCESS,
    payload: { message },
  };
};

export const activateCompany = (idCompany, active) => {
  return {
    type: ACTIVATE_COMPANY,
    payload: { idCompany, active },
  };
};
export const activateCompanySuccess = (message) => {
  return {
    type: ACTIVATE_COMPANY_SUCCESS,
    payload: { message },
  };
};

export const cleanQueue = (client_id, skill_id) => {
  return {
    type: CLEAN_QUEUE,
    payload: { client_id, skill_id },
  };
};

export const cleanQueueSuccess = (message) => {
  return {
    type: CLEAN_QUEUE_SUCCESS,
    payload: { message },
  };
};

export const resetSuccess = () => {
  return {
    type: RESET_SUCCESS,
    payload: {},
  };
};
